module.exports = __webpack_public_path__ + "media/components/src/assets/images/tables/block_table_1-4d776070538db81c333abc96c9ccaf2f.jpg";